module.exports = __webpack_public_path__ + "img/gallery.77d470c5.svg";